import Modal from 'react-modal';
import { JsxElement } from 'typescript';

type ConfirmModalProps = {
    isOpen?: boolean;
    onConfirmAction: () => void;
    onCloseModal: () => void;    
    text: JSX.Element;
    refuseButtonName?: string;
    acceptButtonName?: string;
    };

export default function ConfirmModal({isOpen = false, onConfirmAction, onCloseModal, text, refuseButtonName, acceptButtonName}: ConfirmModalProps) { 
    return(
        <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
            <div className="modale open">
                <div className="modale--content">
                <div className="modale--content--template">
                    <div className="modale--main-width-entreprise p-lg shadow-bleu m-y-xl bg-blanc ">
                        <div className="">
                            <div className="mb-lg mt-lg text"> 
                                {text}
                            </div>
                            <div>
                            
                            <div className="ta-center">
                                <button className="cta-inline-bleu m-x-md button-bloc" onClick={onCloseModal}>{refuseButtonName ? refuseButtonName : 'Annuler'}</button>
                                <button className="cta-bleu cta-small ml-x-md" onClick={onConfirmAction}>{acceptButtonName ? acceptButtonName : 'Confirmer'}</button>
                                
                            </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
                </div>
            </div>
        </Modal>
    )
}